import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { addIssueTypeModalActions } from '@atlassian/jira-project-settings-apps-add-issue-type';
import { REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL } from '../../model/constants';
import {
	LOAD_APP_DATA_FAILURE,
	REFRESH_DATA_FAILURE,
	REFRESH_DATA_REQUEST,
	SET_APP_DATA,
} from '../../state/actions/app';
import type { Action, ActionsObservable } from '../../state/types';

// This epic observe for the REFRESH_DATA_REQUEST action
// if the source is REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL
// then close the modal within the threshold or if the load app data failed or successful
export const refreshDataAddIssueTypeEpic = (action$: ActionsObservable) =>
	action$
		.ofType(REFRESH_DATA_REQUEST)
		.filter(({ payload }) => payload.source === REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL)
		.switchMap(() =>
			action$
				.ofType(SET_APP_DATA, LOAD_APP_DATA_FAILURE, REFRESH_DATA_FAILURE)
				.take(1)
				.flatMap(() => {
					addIssueTypeModalActions()?.closeAddIssueTypeModal();
					return Observable.empty<Action>();
				})
				.catch((error) => {
					fireErrorAnalytics({
						error,
						meta: {
							id: 'backlog.refresh-data-add-issue-type-epic.failure',
							packageName: 'jiraSoftwareBacklog',
							// eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
							teamName: 'jlove-makkuro',
						},
					});
					return Observable.empty<Action>();
				}),
		);
